import { Outlet } from 'react-router-dom';
import CompanyFooter from './CompanyFooter';
import SiteNav from './SiteNav';

function Layout() {
  return (
    <div className="App">
      <SiteNav />
      <Outlet />
      <CompanyFooter />
    </div>
  );
}

export default Layout;
